import { api } from '@/utils/api';

const STREET_VIEW_SETTINGS_USER_ID = 'gstreetc54691cf1ae14-4b75-8b6c4fac12f11380';
const SETTINGS_GROUP_KEY = 'GoogleStreetKey';
const SETTINGS_KEY = 'GoogleStreetKey';

type SettingEntry = { key?: string; value?: string };
type SettingsGroup = { groupKey?: string; settings?: SettingEntry[] };

let token: string | null = null;
let inFlightRequest: Promise<string | null> | null = null;

const extractToken = (data: unknown): string | null => {
	if (!Array.isArray(data)) return null;
	const group = (data as SettingsGroup[]).find((item) => item?.groupKey === SETTINGS_GROUP_KEY);
	const setting = group?.settings?.find((item) => item?.key === SETTINGS_KEY);
	return setting?.value ?? null;
};

export class StreetViewTokenService {
	static getToken(): string | null {
		return token;
	}

	static async fetchToken(): Promise<string | null> {
		if (inFlightRequest) return inFlightRequest;

		inFlightRequest = api
			.get(`users/${STREET_VIEW_SETTINGS_USER_ID}/settings`)
			.then((response) => {
				token = extractToken(response?.data);
				return token;
			})
			.catch(() => null)
			.finally(() => {
				inFlightRequest = null;
			});

		return inFlightRequest;
	}

	static prefetch(): Promise<string | null> {
		if (token) return Promise.resolve(token);
		return this.fetchToken();
	}

	static async getValidToken(): Promise<string | null> {
		if (token) return token;
		return this.fetchToken();
	}

	static clear(): void {
		token = null;
		inFlightRequest = null;
	}
}

export default StreetViewTokenService;
